import { Icon, Input } from "@evergis/ui";
import React, { FC, ReactNode, useCallback, useState } from "react";
import { TagsList } from "../TagsList";

export interface TagsInputProps {
  tags: string[];
  width: string;
  label: ReactNode;
  onTagAdd: (tag: string) => void;
  onTagDelete: (tag: string) => void;
}

export const TagsInput: FC<TagsInputProps> = ({ tags, width, label, onTagAdd, onTagDelete }) => {
  const [value, setValue] = useState("");
  const onAdd = useCallback(() => {
    if (value && !tags.includes(value)) {
      onTagAdd(value);
      setValue("");
    }
  }, [value, tags, onTagAdd]);

  return (
    <>
      <Input
        width={width}
        label={label}
        value={value}
        onKeyDown={e => e.code === "Enter" && onAdd()}
        onChange={e => setValue(e.target.value)}
      >
        <Icon onClick={onAdd} kind={"feature_add"} />
      </Input>
      <TagsList tags={tags} onTagDelete={onTagDelete} />
    </>
  );
};
